/**
 * ブラウザが読む補正サーバーの場所（Issue #863）。
 *
 * 補正サーバーはふだん本番と同じ origin（CloudFront の `/live/*` → EC2）にいる。家・会場の Windows の補正サーバー（LAN）は
 * 証明書つきの https の口（`https://home.ds.synchro-3384.com:8443` など）を本番に知らせ、本番の `GetLiveServer` がそれを教える。
 * `/live/...` を読む所は全部 `liveUrl()` を通す（そのときの口を前に付ける。無ければ同じ origin のまま）。
 * 最後に教わった口は localStorage に残し、開いた直後から使う（`refreshLiveBase` が読み直して差し替える）。
 */
const KEY = 'liveBrowserUrl';

let base = (() => {
  try { return localStorage.getItem(KEY) || ''; } catch { return ''; }
})();

/** 今の口（同じ origin なら ''） */
export const liveBase = () => base;

/** `/live/...` → そのときの補正サーバーの URL（ほかの道はそのまま） */
export const liveUrl = (path) => (base && typeof path === 'string' && path.startsWith('/live') ? `${base}${path}` : path);

/** 本番に聞き直す（`project(action, params)`＝ api.project）。読めなければ今のまま */
export async function refreshLiveBase(project) {
  try {
    const r = await project('GetLiveServer', {});
    const next = (r?.browser_url || '').replace(/\/+$/, '');
    if (next !== base) {
      base = next;
      try { if (next) localStorage.setItem(KEY, next); else localStorage.removeItem(KEY); } catch { /* 残せなくても動く */ }
    }
  } catch { /* 本番が寝ている・古い本番: 今のまま */ }
  return base;
}

/** テスト用 */
export function setLiveBaseForTest(v) { base = v || ''; }
